import { Component, OnInit } from '@angular/core';
import { DataProviderService } from "../../../service/data-provider.service";
import { ActivatedRoute } from "@angular/router";
@Component({
  selector: 'app-teamknowmore',
  templateUrl: './teamknowmore.component.html',
  styleUrls: ['./teamknowmore.component.css']
})
export class TeamknowmoreComponent implements OnInit {
  personalData
  constructor(public data: DataProviderService, public route: ActivatedRoute) {
    let id = this.route.snapshot.paramMap.get("id");
    this.personalData = this.data.personalwebpageteam[id];
    // else if(type==="staff")
    // this.personalData = this.data.staff[id];
  }

  ngOnInit() {
    window.scrollTo(0, 0);
  }
}
